// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hblL","name":"styles_name__1Hw8k","phone":"styles_phone__3_Kti"};